import { Message, MessageOptions } from '../../models/'
import { Utils } from '../../../helpers'
import { Observable } from 'rxjs/Rx'
import { Subject } from 'rxjs/Subject'

export class MessageService {

  private _lastMessageId: number = 0
  private _messageReceivedEmitter: Subject<Message>

  constructor(
    private _utils: Utils
  ) {
    this._messageReceivedEmitter = new Subject<Message>()
  }

  public createErrorMessage(messageText: string, messageOptions?: any): Message {
    return this.createMessageWithCategory('error', messageText, messageOptions)
  }

  public createSuccessMessage(messageText: string, messageOptions?: any): Message {
    return this.createMessageWithCategory('success', messageText, messageOptions)
  }

  public createWarningMessage(messageText: string, messageOptions?: any): Message {
    return this.createMessageWithCategory('warning', messageText, messageOptions)
  }

  public createInfoMessage(messageText: string, messageOptions?: any): Message {
    return this.createMessageWithCategory('info', messageText, messageOptions)
  }

  public send(message: Message) {
    this._messageReceivedEmitter.next(message)
    return message
  }

  public onMessageReceived(): Observable<Message> {
    return this._messageReceivedEmitter
  }

  private createMessageWithCategory(
    category: 'error'|'info'|'warning'|'success',
    messageText: string, messageOptions?: any
  ) {

    return this.createMessage(
      messageText,
      this.mergeMessageOptions( messageOptions, { category: category } )
    )
  }

  private createMessage(messageText: string, messageOptions: any = {}) {
    const messageId = this.generateMessageId()

    const options = this.mergeMessageOptions({
      timestamp: new Date()
    }, messageOptions, {
      id: messageId,
      message: messageText
    }) as MessageOptions

    return new Message(options, this._utils)
  }

  private generateMessageId() {
    const nextId = ++this._lastMessageId
    return nextId.toString()
  }

  private mergeMessageOptions(source1: any, source2: any, ...sourceN: any[]): any {
    return Object.assign({}, source1, source2, ...sourceN)
  }
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/core/services/message/message.service.ts